import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@rainbow-me/rainbowkit/styles.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { WagmiProvider } from 'wagmi';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { config } from './wagmi';
import { WalletPortfolioProvider } from './context/WalletPortfolioContext';

// Optimized QueryClient configuration for better performance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 15 seconds (positions/allowance need to feel live)
      staleTime: 15 * 1000,
      // Keep data in cache for 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry failed queries once
      retry: 1,
      // Refetch on window focus (for balance updates)
      refetchOnWindowFocus: true,
      // Don't refetch on reconnect (prevent spam)
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

// Custom theme matching your app's dark theme
const customDarkTheme = darkTheme({
  accentColor: '#00d4ff', // Teal accent
  accentColorForeground: 'white',
  borderRadius: 'medium',
  fontStack: 'system',
  overlayBlur: 'small',
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={customDarkTheme}
          // Show recent transactions in modal
          showRecentTransactions={true}
          // Modal size
          modalSize="compact"
        >
          <ErrorBoundary>
            <WalletPortfolioProvider>
              <App />
            </WalletPortfolioProvider>
          </ErrorBoundary>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);

